<template>
  <header
    class="border-b border-default dark:border-default min-w-0 bg-default h-16 max-w-[calc(100vw-var(--sidebar-width))]"
  >
    <UContainer class="shrink-0 flex items-center justify-between h-full">
      <div>
        <slot name="left">
          <UBreadcrumb :items="breadcrumbs" v-if="user" />
        </slot>
      </div>

      <div class="flex items-center gap-x-4">
        <ClientOnly v-if="!colorMode?.forced">
          <ColorModeButton />
        </ClientOnly>

        <UPopover v-if="user" :content="{ align: 'end' }">
          <button class="block hover:brightness-90">
            <UAvatar
              :src="user?.avatar ?? undefined"
              :alt="user?.email.toUpperCase()"
              size="sm"
            />
          </button>

          <template #content>
            <UCard
              :ui="{
                body: 'flex flex-col gap-2 p-2 sm:p-2',
                header: 'p-2 sm:p-2 flex items-center gap-x-2',
              }"
            >
              <template #header>
                <UAvatar
                  :src="user?.avatar ?? undefined"
                  :alt="user?.email.toUpperCase()"
                  size="sm"
                />
                <span class="text-sm">{{ user?.username }}</span>
              </template>
              <UButton
                label="Profile"
                variant="ghost"
                color="neutral"
                icon="lucide:user-cog"
                :to="{ name: 'profile' }"
              />
              <UButton
                label="Logout"
                variant="ghost"
                color="neutral"
                icon="lucide:log-out"
                @click="onLogoutClick"
              />
            </UCard>
          </template>
        </UPopover>
      </div>
    </UContainer>
  </header>
</template>

<script lang="ts" setup>
const { user, clear } = useUserSession();

const { breadcrumbs } = storeToRefs(useBreadcrumbStore());

const colorMode = useColorMode();

function onLogoutClick() {
  clear();
  navigateTo("/login");
}
</script>

<style></style>
